import { IFormType } from "../types"

export const OBJECT_TYPE_ID_MAP = {
  contact: "0-1",
}

export const FORM_GUID_MAP: { [key in IFormType]: string } = {
  bpo: "5cf6d196-cb4d-48c6-be3f-3ffbd7f8a6be",
  platform: "dadeccff-e159-45a7-b88b-5f7098a029b2",
}

export const PAGE_NAME_MAP: { [key in IFormType]: string } = {
  bpo: "料金シミュレータ アウトソーシング",
  platform: "料金シミュレータ 導入効果",
}
